global.__litium = global.__litium || {};
window.__litium.themeName = 'wtg';
global.__litium.themeName = 'wtg';

require('./app.js');
